import api from '../../api/index.js'

const state = {

}

const getters = {
}

const actions = {
    getDataDictionaryItemList({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/DataDictionaryItem/List',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    }
    
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
